import { useContext } from "react";
import { CsrContext } from "../contexts/CsrProvider";

export default function useCsr() {
  const context = useContext(CsrContext);

  if (!context) {
    throw new Error("Please Use CsrProvider in parent component.");
  }

  return context;
}
